// Generated by Claude Code
import { useTranslation } from 'react-i18next'
import { CURRENCY_VALUES } from '#core/entities/operations/parts/Part.ts'
import { SearchSelect } from '#components/composites/search-select.tsx'
import type { SelectItem } from '#components/primitives/forms/select.tsx'

const CURRENCY_ITEMS: SelectItem<string>[] = CURRENCY_VALUES.map((value) => ({ value, label: value }))

export interface CurrencySelectProps {
  /** The selected currency code; blank selects none. */
  value: string
  onChange: (currency: string) => void
  disabled?: boolean
}

/** Full-width searchable picker over the currencies a price or rate can be set in, labelled by code. */
export function CurrencySelect({ value, onChange, disabled }: CurrencySelectProps) {
  const { t } = useTranslation('shared')
  return (
    <SearchSelect<string>
      items={CURRENCY_ITEMS}
      selected={CURRENCY_ITEMS.find((item) => item.value === value) ?? null}
      buttonLabel={<span className="ynt-select-placeholder">{t('fields.currency')}</span>}
      buttonAriaLabel={t('fields.currency')}
      buttonClassName="btn-secondary w-100 d-flex justify-content-between align-items-center"
      fullWidth
      dropdownMinWidth="100%"
      listMaxHeight="15rem"
      disabled={disabled}
      onSelectionChange={(change) => { if (change.added) onChange(change.added.value) }}
    />
  )
}
